/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = `<p class="prd-Product_Price fz-18_22"><span class="prd-Price_Value">${formatPrice(price)}</span></p>`;
    if (comparing) {
      res =
      `<p class="prd-Product_Price fz-18_22 prd-Price-sale"><span class="prd-Price_Sale">${formatPrice(compare_at_price)}</span><span class="prd-Price_Value">${formatPrice(price)}</span></p>`;
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    availability: function availability() {
      const canBuy = this.inventory_management !== 'shopify' ||
      this.inventory_policy === 'continue' ||
      this.inventory_quantity > 0

      return (canBuy === true) ? '' : `<span class="prd-Card_Availability">Sold out</span>`
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      return (
        `/products/${  this.handle}`
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    topBadge: function topBadge() {
      let onSale = Number(this.compare_at_price) && Number(this.compare_at_price) > Number(this.price)
      if (window.location.href.indexOf('sale') > -1) onSale = 0

      if (this.named_tags === undefined) return
      
      const topBadgeObject = this.named_tags['top-badge']

      if (topBadgeObject === undefined && onSale === 0) return

      // hide top badge if savings badge is displaying
      const bottomBadgeObject = this.named_tags['bottom-badge']
      const totalSaving = Number(this.compare_at_price) - Number(this.price)
      if (totalSaving > 0.5 && bottomBadgeObject === undefined) return

      if (topBadgeObject !== undefined) {
        const topBadge = topBadgeObject

        const topBadgeTag = Array.isArray(topBadge) ? topBadge[0] : topBadge
        let topBadgeLabel, topBadgeColour, topBadgeLink
  
        if (topBadgeTag.includes('|')) {
          const topBadgeArray = topBadgeTag.split('|')
          topBadgeLabel = topBadgeArray[0]
          topBadgeColour = (topBadgeArray[1] === undefined) ? 'black' : topBadgeArray[1]
          topBadgeLink = topBadgeArray[2]
  
          if (topBadgeLink === undefined) {
            return `<div class="prd-Badge prd-Badge-top prd-Badge-${topBadgeColour}"><div class="prd-Badge_Text">${topBadgeLabel}</div></div>`
          } else {
            return `<div class="prd-Badge prd-Badge-top prd-Badge-${topBadgeColour}"><a href="${topBadgeLink}" class="prd-Badge_Link"><div class="prd-Badge_Text">${topBadgeLabel}</div></a></div>`
          }
        } else {
          topBadgeLabel = topBadgeTag
  
          return `<div class="prd-Badge prd-Badge-top"><div class="prd-Badge_Text">${topBadgeLabel}</div></div>`
        }
      } else {
        return `<div class="prd-Badge prd-Badge-top prd-Badge-red"><div class="prd-Badge_Text">Sale</div></div>`
      }
    },
    savingsBadge: function savingsBadge() {
      let onSale = Number(this.compare_at_price) && Number(this.compare_at_price) > Number(this.price)
      if (window.location.href.indexOf('sale') > -1) onSale = 0
            
      if (onSale !== 0) {
        const totalSaving = Number(this.compare_at_price) - Number(this.price)
        const totalSavingRounded = totalSaving.toFixed(2) % 1 === 0 ? Math.round(totalSaving) : totalSaving.toFixed(2)

        if (totalSavingRounded > 0.5) { 
          return `<div class="prd-Badge prd-Badge-saving fz-11_13">Save £${totalSavingRounded}</div>`
        }
      }
    },
    bottomBadge: function bottomBadge() {
      if (this.named_tags === undefined) return
      
      const bottomBadgeObject = this.named_tags['bottom-badge']
      if (bottomBadgeObject === undefined) return

      const bottomBadge = bottomBadgeObject
      const bottomBadgeTag = Array.isArray(bottomBadge) ? bottomBadge[0] : bottomBadge
      let bottomBadgeLabel, bottomBadgeLink

      if (bottomBadgeTag.includes('|')) {
        const topBadgeArray = bottomBadgeTag.split('|')
        bottomBadgeLabel = topBadgeArray[0]
        bottomBadgeLink = topBadgeArray[2]

        if (bottomBadgeLabel === 'threshold') {
          const thresholdObject = this.named_tags['threshold']
          if (thresholdObject === undefined) return

          const threshold = parseInt(thresholdObject)

          if (this.inventory_quantity > 0 && this.inventory_management === 'shopify' && this.inventory_policy !== 'continue' && threshold >= this.inventory_quantity) {
            return `<div class="prd-Badge prd-Badge-bottom"><div class="prd-Badge_Text">Only ${this.inventory_quantity} remaining</div></div>`
          } else {
            return ''
          }
        } else {
          if (bottomBadgeLink === undefined) {
            return `<div class="prd-Badge prd-Badge-bottom"><div class="prd-Badge_Text">${bottomBadgeLabel}</div></div>`
          } else {
            return `<div class="prd-Badge prd-Badge-bottom"><a href="${bottomBadgeLink}" class="prd-Badge_Link"><div class="prd-Badge_Text">${bottomBadgeLabel}</div></a></div>`
          }
        }
      } else {
        bottomBadgeLabel = bottomBadgeTag

        if (bottomBadgeLabel === 'threshold') {
          const thresholdObject = this.named_tags['threshold']
          if (thresholdObject === undefined) return

          const threshold = parseInt(thresholdObject)

          if (this.inventory_quantity > 0 && this.inventory_management === 'shopify' && this.inventory_policy !== 'continue' && threshold >= this.inventory_quantity) {
            return `<div class="prd-Badge prd-Badge-bottom"><div class="prd-Badge_Text">Only ${this.inventory_quantity} remaining</div></div>`
          } else {
            return ''
          }
        } else {
          return `<div class="prd-Badge prd-Badge-bottom"><div class="prd-Badge_Text">${bottomBadgeLabel}</div></div>`
        }
      }
    },
    countdown: function countdown() {
      if (this.named_tags === undefined) return
      
      let countdownTag = this.named_tags['countdown']
      if (countdownTag === undefined) return

      countdownTag = Array.isArray(countdownTag) ? countdownTag[0] : countdownTag

      countdownTag = countdownTag.split('|')

      const countdownDate = countdownTag[0]
      const countdownTime = countdownTag[1]

      return `<div
        class="prd-Badge prd-Badge-bottom prd-Badge-countdown"
        data-algolia-module="countdown"
        data-countdown-date="${countdownDate}"
        data-countdown-time="${countdownTime}"
      >
        <div class="prd-Badge_Text">
          Flash Sale - 
          <span data-el="countdown.days">00</span>:<span data-el="countdown.hours">00</span>:<span data-el="countdown.minutes">00</span>:<span data-el="countdown.seconds">00</span>
        </div>
      </div>`
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value,
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value,
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
